import React from 'react';
import Header from './Header';
import Footer from './Footer';
import visionImage from '../images/Vision.jpg';
import missionImage from '../images/Mission.jpg';

const AboutUs = () => {
  return (
    <div style={{ 
      background: 'linear-gradient(to right, #91eae4, #86a8e7, #7f7fd5)',
      minHeight: '100vh',
      fontFamily: '"Quicksand", sans-serif'
    }}>
      {/* Header Navigation */}
      <Header />

      {/* Main Content */}
      {/* Header Section */}
      <div className="container mb-5" style={{ paddingTop: '2rem' }}>
        <div className="row align-items-center">
          <div className="col-12 text-center">
            <h1 className="display-6 fw-bold text-white mb-2">About Us</h1>
            <p className="text-white-50 mb-0" style={{ fontSize: '1.1rem', maxWidth: '600px', margin: '0 auto' }}>
              Empowering entrepreneurs and businesses with sustainable growth and ethical practices
            </p>
          </div>
        </div>
      </div>
      {/* Vision Section */}
      <div className="container mb-5">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div style={{
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '20px',
              padding: '2rem',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
            }}>
              <h2 style={{
                color: '#1e40af',
                fontWeight: '700',
                fontSize: '2.5rem',
                marginBottom: '1.5rem',
                textAlign: 'center'
              }}>Vision</h2>
              <div style={{ color: '#1f2937', lineHeight: '1.8', fontSize: '1.1rem' }}>
                <p style={{ marginBottom: '1rem' }}>
                  At <strong>Al-Tijaarat al-Raabehah</strong>, our vision is to empower entrepreneurs and businesses globally to achieve sustainable and profitable growth while upholding the highest moral and ethical standards.
                </p>
                <p style={{ marginBottom: '1rem' }}>
                  We combine the timeless principles of <strong>Shariyat Mohammediyah</strong> with modern business practices to create a positive impact on the global economy. Our approach fosters community connections, collaboration, and international integration.
                </p>
                <p style={{ marginBottom: '1rem' }}>
                  We encourage businesses to adopt cutting-edge practices, diversify supply chains, and embrace innovation while maintaining strong ethical foundations. Our ultimate goal is to empower entrepreneurs for remarkable success and contribute meaningfully to the global economy.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <img 
                src={visionImage}
                alt="Vision - Elderly man writing in notebook"
                style={{
                  width: '100%',
                  maxWidth: '500px',
                  height: 'auto',
                  borderRadius: '20px',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                  transition: 'transform 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.transform = 'scale(1.02)'}
                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Mission Section */}
      <div className="container mb-5">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <img 
                src={missionImage}
                alt="Mission - Group of people in market"
                style={{
                  width: '100%',
                  maxWidth: '500px',
                  height: 'auto',
                  borderRadius: '20px',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                  transition: 'transform 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.transform = 'scale(1.02)'}
                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div style={{
              background: 'white',
              borderRadius: '20px',
              padding: '2rem',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)'
            }}>
              <h2 style={{
                color: '#1e40af',
                fontWeight: '700',
                fontSize: '2.5rem',
                marginBottom: '1.5rem',
                textAlign: 'center'
              }}>Mission</h2>
              <div style={{ color: '#1f2937', lineHeight: '1.8', fontSize: '1.1rem' }}>
                <p style={{ marginBottom: '1rem' }}>
                  Our mission is to assist and empower the <strong>Dawoodi Bohra community</strong> in building profitable and sustainable businesses worldwide under the leadership of <strong>al Dai al Ajal Syedna Mufaddal Saifuddin TUS</strong>.
                </p>
                <p style={{ marginBottom: '1rem' }}>
                  We provide a comprehensive platform and resources for entrepreneurs to thrive, fostering a supportive and collaborative environment that enhances economic prosperity within our community.
                </p>
                <p style={{ marginBottom: '1rem' }}>
                  Through our initiatives, we uphold the values instilled by <strong>Syedna Mufaddal Saifuddin TUS</strong>, ensuring that every business venture contributes to the community's progress and well-being while maintaining the highest standards of integrity and excellence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer Spacing */}
      <div style={{ paddingBottom: '3rem' }}></div>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default AboutUs; 